import { enumFilterOption } from 'src/types/filter-types';

export const filterOptions = {
    [enumFilterOption.onAuction]: 'On Auction',
    [enumFilterOption.buyNow]: 'Buy Now',
    [enumFilterOption.hasBids]: 'Has Bids',
    [enumFilterOption.new]: 'New',
};
